import { createSelector } from '@ngrx/store';

import dayjs                                from 'dayjs';

import {
  CampaignExecutionEvent,
  OneShotCampaignConfig
} from '../../../mediego-common-module/declarations/campaign-config';

import { getFutureEvents }                  from '../../utils/campaign.utils';
import { campaignsAdapter, CampaignsState } from '../reducers/campaigns.reducer';

import { selectCampaignsState }             from './index';

const {
  selectAll
} = campaignsAdapter.getSelectors();


export const selectAllCampaigns = createSelector(
  selectCampaignsState,
  (state: CampaignsState) =>
    selectAll(state)
);

export const selectEditorialPlanifications = createSelector(
  selectCampaignsState,
  (state: CampaignsState) => state.editorialPlanifications
);

export const selectActiveEditorialTimestamp = createSelector(
  selectCampaignsState,
  (state: CampaignsState) => state.activeEditorialTimestamp
);

export const selectHasAnyEditorialPlanification = createSelector(
  selectEditorialPlanifications,
  (editorials) => editorials.length > 0
);

export const selectFutureEvents = createSelector(
  selectCampaignsState,
  (state: CampaignsState) => {
    const eventList: CampaignExecutionEvent[] = [];
    const overrides: OneShotCampaignConfig[] = [];

    const dateLimit = dayjs().add(3, 'month');

    selectAll(state).forEach((campaign) => {
      if ((campaign as OneShotCampaignConfig).overrides) {
        overrides.push((campaign as OneShotCampaignConfig));
      } else {
        getFutureEvents(campaign, dateLimit).forEach(date => {
          const editorial = state.editorialPlanifications.find(__ => __.timestamp === date.valueOf());
          eventList.push({
            campaignId: campaign.id.id,
            date,
            isEnabled: campaign.enabled,
            editorialTimestamp: editorial?.timestamp
          });
        });
      }
    });

    overrides.forEach((override) => {
      const index = eventList.findIndex((__: CampaignExecutionEvent) => __.date.valueOf() === override.timestamp);
      if (index > -1) {
        eventList[index].isEnabled = false;
      }
    });

    return eventList.sort((a, b) => a.date.isAfter(b.date) ? 1 : -1);
  }
);

export const selectNextEditorializedEventTimestamp = createSelector(
  selectFutureEvents,
  (events) => events.find(__ => __.isEnabled)?.editorialTimestamp ?? null
);
